// @ts-ignore
import queryString from "query-string";

const selectors: Record<"block" | "filters", string> = {
  block: "[data-ui-filter]",
  filters: "[data-ui-filter-item]",
};

const elements: Record<
  "block" | "filters",
  null | undefined | HTMLElement | NodeListOf<Element> | HTMLElement[]
> = {
  block: null,
  filters: null,
};

function onChangeSelect(e: Event) {
  const query = {
    ...queryString.parse(location.search),
    // @ts-ignore
    [e.target.id]: e.target.getAttribute("data-default") === e.target.value ? "" : e.target.value,
  };

  let url: string | string[] = window.location.pathname.split("/");
  const fiendPageIndex = url.findIndex((i) => i === "page");

  if (fiendPageIndex) {
    url = url.reduce((acc, item, key) => {
      if (key === fiendPageIndex || key === fiendPageIndex + 1) return acc;
      return [...acc, item];
    }, [] as string[]);
  }

  url = window.location.origin + "/" + url.join("/");

  // @ts-ignore
  if (history.pushState) {
    const newUrl = queryString.stringifyUrl(
      {
        // @ts-ignore
        url,
        query,
      },
      {
        skipEmptyString: true,
      }
    );
    // @ts-ignore
    window.location = newUrl;
  }
}

function setActiveFilters() {
  const parse = queryString.parse(location.search);

  if (!elements.filters) return;

  Object.keys(parse).map((name) => {
    // @ts-ignore
    elements.filters?.forEach((filter: Element) => {
      Array.from(filter.querySelectorAll("option")).forEach((option) => {
        if (filter.id === name) {
          if (parse[name] === option.value) {
            option.setAttribute("selected", "");
            return;
          }

          option.removeAttribute("selected");
        }
      });
    });
  });
}

function init() {
  elements.block = document.querySelector(selectors.block) as HTMLElement;
  elements.filters = Array.from(document.querySelectorAll(selectors.filters) || []);

  if (!elements.block) return;

  elements.filters.forEach((filter) => filter.addEventListener("change", onChangeSelect));
  setActiveFilters();
}

document.addEventListener(
  "DOMContentLoaded",
  async function () {
    init();
  },
  {
    once: true,
  }
);
